var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarMenu',{staticStyle:{"z-index":"1050"},attrs:{"menu":_vm.menu,"collapsed":_vm.collapsed},on:{"toggle-collapse":_vm.onToggleCollapse,"item-click":_vm.onItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }